import { PUBLIC_API_BASE_URL } from "./api";

// Always the public origin, never the server-only internal shortcut: a
// media URL ends up in an <img src> the visitor's own browser fetches,
// unlike API calls which can legitimately run server-to-server.
const MEDIA_ORIGIN = PUBLIC_API_BASE_URL.replace(/\/api\/?$/, "");

export function mediaUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${MEDIA_ORIGIN}${path}`;
}
